import styles from './Icon.module.css';

const types = [
	'apple-icon',
	'arrow-up',
	'arrow-down',
	'arrow-right',
	'arrow-left',
	'bookmark',
	'bookmark-selected',
	'bookmarks',
	'done',
	'email',
	'font',
	'font-selected',
	'font-increase',
	'font-decrease',
	'toc',
	'horizontal-split',
	'download',
	'downloaded',
	'search',
	'search-alt',
	'cloud-off',
	'home',
	'home-selected',
	'player',
	'article',
	'share',
	'play-arrow',
	'pause',
	'forward-5',
	'replay-5',
	'cancel',
	'chevron-left',
	'chevron-right',
	'close',
	'cloud',
	'cloud-queue',
	'add-link',
	'attach-email',
	'pending',
	'cloud-done',
	'single-page-spread',
	'double-page-spread',
	'responsive-mode',
	'replica-mode',
	'external-link',
	'printer',
	'zoom-in',
	'sidebar',
	'more-horizontal',
	'align-left',
	'calendar',
	'library',
	'globe',
	'logout',
	'x',
	'eye',
	'info',
	'award',
	'book',
	'book-open',
] as const;

export type IconType = (typeof types)[number];

export const isValidIconType = (x: any): x is IconType => types.includes(x);

export const Icon = (props: IconProps) => {
	const { id, name, color = '#000', opacity = 1 } = props;
	if (!isValidIconType(name)) {
		return null;
	}

	const className = [styles['icon'], styles[name]];

	const style = {
		backgroundColor: color,
		maskPosition: 'center',
		opacity,
	};
	return <div id={id} style={style} className={className.join(' ')} />;
};

interface IconProps {
	id?: string;
	name: IconType | null;
	color?: string;
	opacity?: number;
}
